// src/components/HealthInitiative.jsx
import React from 'react';
import './HealthInitiative.css';

const HealthInitiative = () => {
  const interventions = [
    'Primary Health Centre Upgrades',
    'Medical Equipment Deployment',
    'Community Health Outreach',
    'Solar-Powered Health Facilities',
    'Climate-Resilient Health Systems'
  ];

  return (
    <section className="health-section">
      <div className="health-container">
        <div className="health-content">
          <div className="health-header">
            <span className="health-badge">CSR INITIATIVE</span>
            <h2 className="health-title">Health Impact Initiative</h2>
            <p className="health-subtitle">Pre-Summit Health Systems Strengthening Programme</p>
            <div className="health-title-line"></div>
          </div>

          <div className="health-grid">
            <div className="health-left">
              <div className="health-objective">
                <h4>🎯 Objective</h4>
                <p>Deliver measurable community impact while advancing ESG-aligned investment.</p>
              </div>

              <div className="health-interventions">
                <h4>Key Interventions</h4>
                <ul>
                  {interventions.map((item, index) => (
                    <li key={index}>
                      <span className="checkmark">✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="health-right">
              <div className="health-impact">
                <h4>Target Impact</h4>
                <div className="impact-stats">
                  <div className="impact-stat">
                    <div className="impact-number">4-8</div>
                    <div className="impact-label">PHCs Upgraded</div>
                  </div>
                  <div className="impact-stat">
                    <div className="impact-number">5,000-15,000</div>
                    <div className="impact-label">Beneficiaries Reached</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthInitiative;